export default {
  zh: {
    noenough: '您没有足够的硬币来玩老虎机',
    later: '稍后',
    exchange: '兑换',
    close: '关闭',
    yes: '确定',
    title: '金币兑换',
    desc: '点击提取按钮手动提取黄金'
  },
  en: {
    noenough: "You don't have enough coins to play slot",
    later: 'Later',
    exchange: 'Exchange',
    close: 'Close',
    yes: 'Confirm',
    title: 'Gold Exchange',
    desc: 'Click the extract button to manually extract gold'
  },
  ar: {
    noenough: "You don't have enough coins to play slot",
    later: 'Later',
    exchange: 'Exchange',
    close: 'Close',
    yes: 'Confirm',
    title: 'Gold Exchange',
    desc: 'Click the extract button to manually extract gold'
  },
  uz: {
    noenough: "Slot o'ynash uchun yetarli tangalaringiz yo'q",
    later: 'Keyinroq',
    exchange: 'Almashtirish',
    close: 'Yopish',
    yes: 'Tasdiqlash',
    title: 'Oltin Almashtirish',
    desc: "Qo'lda oltin olish uchun chiqarish tugmasini bosing"
  },
  ru: {
    noenough: 'У вас недостаточно монет для игры в слот',
    later: 'Позже',
    exchange: 'Обмен',
    close: 'Закрыть',
    yes: 'Подтвердить',
    title: 'Обмен золота',
    desc: 'Нажмите кнопку извлечения, чтобы вручную извлечь золото'
  },
  fa: {
    noenough: 'شما برای بازی اسلات سکه کافی ندارید',
    later: 'بعداً',
    exchange: 'تعویض',
    close: 'بستن',
    yes: 'تأیید',
    title: 'تعویض طلا',
    desc: 'برای استخراج طلا به صورت دستی، دکمه استخراج را بزنید'
  },
  pt: {
    noenough: 'Você não tem moedas suficientes para jogar no slot',
    later: 'Mais tarde',
    exchange: 'Trocar',
    close: 'Fechar',
    yes: 'Confirmar',
    title: 'Troca de Ouro',
    desc: 'Clique no botão de extrair para extrair o ouro manualmente'
  },
  id: {
    noenough: 'Anda tidak memiliki cukup koin untuk bermain slot',
    later: 'Nanti',
    exchange: 'Tukar',
    close: 'Tutup',
    yes: 'Konfirmasi',
    title: 'Pertukaran Emas',
    desc: 'Klik tombol ekstrak untuk mengekstrak emas secara manual'
  },
  ur: {
    noenough: 'آپ کے پاس سلاٹ کھیلنے کے لیے کافی سکے نہیں ہیں',
    later: 'بعد میں',
    exchange: 'تبادلہ',
    close: 'بند کریں',
    yes: 'جی ہاں',
    title: 'سونے کا تبادلہ',
    desc: 'سونے کو دستی طور پر نکالنے کے لیے نکالنے کے بٹن پر کلک کریں'
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-FruitSlots/lang.js